import { render, staticRenderFns } from "./ErrorNotFound.vue?vue&type=template&id=6aa60194&"
import script from "./ErrorNotFound.vue?vue&type=script&lang=ts&"
export * from "./ErrorNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorNotFound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
